import type { NodeParamBase } from '../types/NodeParamBase';
import { mapNodeParamTypeToString } from './mapNodeParamTypeToString';

export const mapNodeParamToString = (param: NodeParamBase): string => {
  const typeString = mapNodeParamTypeToString(param.type);
  const paramWithArray = param.isArray ? `Array of ${typeString}s` : typeString;

  return param.isRequired ? `Required ${paramWithArray}` : paramWithArray;
};
